import b from 'b_';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';
import { BrandingOption } from '../../stores/BrowserBarOptions';
import ConsoleStore from '../../stores/ConsoleStore';
import { CUSTOMIZATION_TYPE } from '../../stores/CustomizeUI/CustomizeUIConstants';
import CustomizeUIStore from '../../stores/CustomizeUI/CustomizeUIStore';
import { Card, Page } from '../Fuse';
import Table from '../Fuse/Table';
import FuseMenu from '../FuseControls/FuseMenu';
import CustomizeBlockPageModal from './CustomizeBlockPageModal';
import CustomizeBrowserBarModal from './CustomizeBrowserBarModal';
import CustomizeExitIsolationModal from './CustomizeExitIsolationModal';
import CustomizeRegistrationNoticeModal from './CustomizeRegistrationNoticeModal';
import CustomizeUIReadOnlyModal from './CustomizeUIReadOnlyModal';
import './CustomizeUIPage.css';

const block = b.lock('CustomizeUIPage');

const customOrDefault = (isCustom) => (isCustom ? 'Custom' : 'Default');

class CustomizeUIPage extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        customizeUI: CustomizeUIStore.PropType.isRequired,
    };

    componentDidMount() {
        const { console, customizeUI } = this.props;
        customizeUI.browserBarOptions.visible.setValue(console.canCustomizeBrowserBar());
        customizeUI.exitMessage.visible.setValue(console.menuHasNew()
            && ((console.hasBrowserOrEmailLicense() && console.urlIsolationProductEnabled)
                || console.hasTapUrlIsolationLicense()));
        customizeUI.registrationNotice.visible.setValue(console.hasBrowserOrEmailLicense());
        this.props.customizeUI.load();
    }

    renderOption = {
        [CUSTOMIZATION_TYPE.CONTENT_FILTERING]: (store) => customOrDefault(store.enabled.getValue()),
        [CUSTOMIZATION_TYPE.MALICIOUS_THREAT]: (store) => customOrDefault(store.enabled.getValue()),
        [CUSTOMIZATION_TYPE.BROWSER_BAR]: (store) =>
            customOrDefault(store.brandingOption.equals(BrandingOption.CUSTOM)),
        [CUSTOMIZATION_TYPE.EXIT_MESSAGE]: (store) => customOrDefault(store.option.equals('CUSTOM')),
        [CUSTOMIZATION_TYPE.REGISTRATION_NOTICE]: (store) => (store.enabled.getValue()
            ? 'Enabled' : <span style={{ color: '#F44336' }}>Disabled</span>),
    };

    columns = [{
        name: 'type',
        title: 'Type',
        render: (item) => item.metadata.type,
    }, {
        name: 'name',
        title: 'Name',
        render: (item) => item.metadata.name,
    }, {
        name: 'description',
        title: 'Description',
        render: (item) => item.metadata.description,
    }, {
        name: 'option',
        title: 'Option',
        render: (item) => this.renderOption[item.metadata.customizationType]?.(item),
    }, {
        name: 'menu',
        title: '',
        render: (item) => {
            if (this.props.console.authority === ROLE_READ_ONLY.value) {
                return null;
            }

            const actions = [{
                label: 'Edit',
                icon: 'edit',
                disabled: item.isPrimary,
                onClick: item.editModal.open,
            }];
            return <FuseMenu
                open={this.props.customizeUI.menu.getValue() === item}
                toggle={() => this.props.customizeUI.menu.toggle(item)}
                items={actions}
            />;
        },
    }];

    render() {
        const { customizeUI } = this.props;
        return <Page title="Customize UI">
            <Card noPadding>
                <Table
                    cellClassName={block('Cell')}
                    items={customizeUI.filteredList}
                    loading={customizeUI.loadStatus.isLoading}
                    columns={this.columns}
                    searchPlaceholder="Search by Name"
                    search={customizeUI.search}
                    onRowClick={customizeUI.readOnlyModal.toggle}
                />
            </Card>
            <CustomizeUIReadOnlyModal/>
            <CustomizeExitIsolationModal/>
            <CustomizeBrowserBarModal/>
            <CustomizeBlockPageModal
                store={customizeUI.contentFiltering}
                enableTooltip="Display Proofpoint's default content filtering block page
                               or customize the page to match your company's needs."
            />
            <CustomizeBlockPageModal
                store={customizeUI.maliciousThreat}
                enableTooltip="Display Proofpoint's default malicious threat block page
                               or customize the page to match your company's needs."
            />
            <CustomizeRegistrationNoticeModal/>
        </Page>;
    }
}

export default inject('console', 'customizeUI')(observer(CustomizeUIPage));
